const LOCALE_SYNONYMS: Record<string, string> = {
  'ru': 'ru-RU',
  'uk': 'uk-UA',
  'lv-lv': 'ru-RU',
  
  'cs': 'cs-CZ',
  'de': 'de-DE',
  'sv': 'sv-FI',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'fr': 'fr-FR',
  'tr': 'tr-TR',
  'es': 'es-ES'
};

export function getBrowserLanguage(normalize = true): string|null {
  const cultureLang = getBrowserCultureLang();

  if(undefined === cultureLang) {
    return null;
  }

  const browserLang = cultureLang.toLowerCase();

  if(!normalize) {
    return browserLang;
  }

  for(const partial in LOCALE_SYNONYMS) {
    if(browserLang.startsWith(partial)) {
      return LOCALE_SYNONYMS[partial];
    }
  }

  return browserLang;
}

export function getBrowserCultureLang(): string|undefined {
  if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
    return undefined;
  }

  let browserCultureLang: string|undefined = window.navigator.languages ?
    window.navigator.languages[0] :
    undefined;

  browserCultureLang = browserCultureLang ||
    window.navigator.language ||
    (window.navigator as any).browserLanguage ||
    (window.navigator as any).userLanguage;

  return browserCultureLang;
}